import { computed, effect, type Signal, signal } from 'alien-deepsignals'

type Pagination = { index: Signal<number>; size: number; total: number } | null

export const adsPagination = signal<Pagination | undefined>(getAdsPaginationFromStorage())

export const hasMoreAds = computed(() => {
  const pagination = adsPagination.get()
  if (pagination) {
    return (pagination.index.get() + 1) * pagination.size < pagination.total
  }
  return false
})

effect(() => {
  const pagination = adsPagination.get()
  if (pagination) {
    const serialized = {
      index: pagination.index.get(),
      size: pagination.size,
      total: pagination.total,
    }
    localStorage.setItem('research_chat_ads_pagination', JSON.stringify(serialized))
  } else {
    localStorage.removeItem('research_chat_ads_pagination')
  }
})

function getAdsPaginationFromStorage(): Pagination {
  const pagination = localStorage.getItem('research_chat_ads_pagination')

  if (pagination) {
    try {
      const { index, size, total } = JSON.parse(pagination)
      if (typeof index === 'number' && typeof size === 'number' && typeof total === 'number') {
        return { index: signal(index), size, total }
      }
    } catch {
      console.warn('Failed to parse ads pagination from session storage')
    }
  }

  return null
}

export function setAdsPagination(config: { size: number; total: number } | undefined) {
  if (config === undefined) {
    adsPagination.set(undefined)
  } else {
    adsPagination.set({ index: signal(0), size: config.size, total: config.total })
  }
}

export function increaseIndex() {
  const pagination = adsPagination.get()
  if (pagination && hasMoreAds.get()) {
    pagination.index.set(pagination.index.get() + 1)
  }
}
